import { PORTAL, type PortalEvent, type PortalEventType, type PortalTransport } from '../../core/portal';

type MessageTarget = {
    postMessage(message: any): void;
    addEventListener(type: string, listener: (event: MessageEvent) => void): void;
    removeEventListener(type: string, listener: (event: MessageEvent) => void): void;
    start?(): void;
    terminate?(): void;
};

export class MainThreadTransport implements PortalTransport {
    public constructor(private target: MessageTarget) {}

    public async open() {
        this.target.start?.();
    }

    public async close() {
        this.target.terminate?.();
    }

    public send(payload: PortalEvent<PortalEventType>): void {
        this.target.postMessage(payload);
    }

    public receive<E extends PortalEventType>(eventType: E, handler: (event: PortalEvent<E>) => void): () => void {
        const callback = (message: MessageEvent) => {
            const event = message.data as PortalEvent<E>;
            if (event?.type === eventType && event?.$owner === PORTAL) {
                handler(event);
            }
        };
        this.target.addEventListener('message', callback);
        return () => this.target.removeEventListener('message', callback);
    }
}
